import styled from 'styled-components';

export const Input = styled.input`
  width: 0;
  height: 0;
  opacity: 0;
  visibility: hidden;

  &:checked + span {
    border-color: #121827;

    &:after {
      display: block;
    }
  }

  &:disabled + span {
    border-color: #B6B6B6;

    &:after {
      background-color: #B6B6B6;
    }
  }
`;

export const Label = styled.label<{
  checked?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${props => (props.disabled ? '#b6b6b6' : '#121827')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const Icon = styled.span`
  height: 17px;
  width: 17px;
  border-radius: 50%;
  border: 1px solid #121827;
  display: inline-block;
  position: relative;
  cursor: pointer;

  &:after {
    content: '';
    width: 15px;
    height: 15px;
    display: none;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    right: 1px;
    background-color: #121827;
  }
`;
